
import store from '@/store'

import NotFound from '@/pages/NotFound'
import Register from '@/pages/Register'
import Login from '@/pages/Login'

export default [
  {
    path: '/register',
    name: 'Register',
    component: Register,
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      requiresGuest: true
    }
  },
  {
    path: '/logout',
    name: 'Logout',
    beforeEnter (to, from, next) {
      store.dispatch('auth/endIdentity')
        .then(() => {
          store.dispatch('auth/signOut')
            .then(() => {
              next({ name: 'Login' })
            })
        })
    }
  },
  {
    path: '/end-identity',
    name: 'EndIdentity',
    beforeEnter (to, from, next) {
      store.dispatch('auth/endIdentity')
        .then(() => {
          window.location.href = '/clients/'
        })
    }
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound
  }
]
